function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _excluded = ["id", "active", "shouldBePanel", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.sort.js";
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import { reduxForm } from 'redux-form';
import { Box, Tabs, TabPanel, useId } from '@applyboard/ui-components';
import { capitalize, isNumeric, raiseErrorMessage, useEventTracker } from '@applyboard/ui-utils';
import QuestionsModal from "../QuestionsModal";
import DropzoneOverlay from "../../../../components/core/ui/DropzoneOverlay";
import ProgressBarOverlay from "../../../../components/ProgressBarOverlay";
import RequiredStateOptions from "./RequiredStateOptions";
import RequirementCardContent from "./RequirementCardContent";
import LinkedApplicationsListModal from "../LinkedApplicationsListModal";
import Modal from "../../../../components/Modal";
import { RequirementCardWrapper, RequirementContentWrapper } from "./style";
import { useRefreshRequirementStatus, useDeleteAndRefreshRequirementAttachments, UnknownDeleteRequirementAttachmentError } from "../utils";
import { getApplicationStatusMessage } from "../../../../util/common";
import { FulfillmentMessageCode, requiredStateOptions, requiredStateOptionsForm } from "./const";
import useInitialProps from "../../../../hooks/useInitialProps";
import { statuses } from "../../../../components/Applications/ApplicationStatus/consts";
import { isInternalRequirement } from "../../../../data/requirements";
import { loadBaseApplication } from "../../enhancer";
var RequirementCard = function RequirementCard(_ref) {
  var _requirement$applicat, _requirement$applicat2, _application$program;
  var dropzoneDragging = _ref.dropzoneDragging,
    dropzoneHovering = _ref.dropzoneHovering,
    onFiles = _ref.onFiles,
    onStatusChange = _ref.onStatusChange,
    onToggleConditionModal = _ref.onToggleConditionModal,
    preview = _ref.preview,
    previewRequirement = _ref.previewRequirement,
    progressProps = _ref.progressProps,
    requirement = _ref.requirement,
    statusReadOnly = _ref.statusReadOnly,
    userPermissions = _ref.userPermissions,
    application = _ref.application,
    onEdit = _ref.onEdit,
    dispatch = _ref.dispatch,
    isApplicantRequirement = _ref.isApplicantRequirement,
    _ref$verificationModa = _ref.verificationModalAttachmentIds,
    verificationModalAttachmentIds = _ref$verificationModa === void 0 ? [] : _ref$verificationModa,
    setVerificationModalAttachmentIds = _ref.setVerificationModalAttachmentIds,
    entityName = _ref.entityName,
    selectedTab = _ref.selectedTab,
    selectedPreviewRequirementId = _ref.selectedPreviewRequirementId,
    highlightedRequirementId = _ref.highlightedRequirementId,
    DocumentVerificationModal = _ref.DocumentVerificationModal,
    reloadAggregatedData = _ref.reloadAggregatedData,
    RemoveFileDialog = _ref.RemoveFileDialog,
    HybridRequirementDecisionReasons = _ref.HybridRequirementDecisionReasons,
    HybridRequirementDialogButton = _ref.HybridRequirementDialogButton,
    aggregatedDataRequirements = _ref.aggregatedDataRequirements;
  var activelyPreviewing = preview && previewRequirement && typeof previewRequirement === 'function' ? selectedPreviewRequirementId === requirement.id : false;
  var onSelectAttachment = function onSelectAttachment(fileId) {
    var _requirement$attachme;
    var indexOfAttachment = requirement === null || requirement === void 0 ? void 0 : (_requirement$attachme = requirement.attachments) === null || _requirement$attachme === void 0 ? void 0 : _requirement$attachme.findIndex(function (element) {
      return element.id === fileId;
    });
    previewRequirement(requirement, indexOfAttachment);
  };
  var initialProps = useInitialProps();
  var internalTabId = useId();
  var externalTabId = useId();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    fulfillmentMessage = _useState2[0],
    setFulfillmentMessage = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    currentTab = _useState4[0],
    setCurrentTab = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    linkedApplicationsModalVisible = _useState6[0],
    setLinkedApplicationsModalVisible = _useState6[1];
  var _useRefreshRequiremen = useRefreshRequirementStatus(),
    refreshRequirementStatus = _useRefreshRequiremen.refreshRequirementStatus,
    isRefreshingRequirementStatus = _useRefreshRequiremen.isRefreshingRequirementStatus;
  var _useEventTracker = useEventTracker({
      group: 'Payment Requirements',
      data: {
        requirementId: requirement === null || requirement === void 0 ? void 0 : requirement.id
      }
    }),
    trackPaymentRequirementEvent = _useEventTracker.trackEvent;
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    questionsModalVisible = _useState8[0],
    setQuestionsModalVisible = _useState8[1];
  var userIsAdmin = (userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.create_requirement_with_template) || (userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.create_requirement_without_template);
  var displayAdditionalAttachments = (requirement === null || requirement === void 0 ? void 0 : (_requirement$applicat = requirement.application_additional_attachments) === null || _requirement$applicat === void 0 ? void 0 : _requirement$applicat.length) > 0;
  var displayExternalLinks = (requirement === null || requirement === void 0 ? void 0 : (_requirement$applicat2 = requirement.application_external_links) === null || _requirement$applicat2 === void 0 ? void 0 : _requirement$applicat2.length) > 0;
  var displayId = requirement === null || requirement === void 0 ? void 0 : requirement.requirement_template_id;
  var name = "required_state_options_".concat(requirement === null || requirement === void 0 ? void 0 : requirement.id);
  var requiredStateTooltip = getRequiredStateTooltip({
    userPermissions: userPermissions,
    requirement: requirement
  });
  var requiredState = requirement === null || requirement === void 0 ? void 0 : requirement.required_state.split('required_state_')[1];
  var status = requirement === null || requirement === void 0 ? void 0 : requirement.status.split('status_')[1];
  var questions = buildQuestionsArray({
    requirement: requirement,
    previewing: false
  });
  var programId = (_application$program = application.program) === null || _application$program === void 0 ? void 0 : _application$program.id;
  var schoolGroupId = application.school_group_id;
  var useDocumentUpload = (requirement === null || requirement === void 0 ? void 0 : requirement.requirement_template_type) === 'document' || (requirement === null || requirement === void 0 ? void 0 : requirement.requirement_template_type) === 'receipt';
  var options = getOptions({
    requirement: requirement,
    requiredState: requiredState
  });
  var conditionTitle = getCondition({
    userIsAdmin: userIsAdmin,
    requirement: requirement
  }).conditionTitle;
  var conditionValues = getCondition({
    userIsAdmin: userIsAdmin,
    requirement: requirement
  }).conditionValues;
  var requirementFlags = getFlags({
    requirement: requirement,
    selectedTab: selectedTab,
    permissions: initialProps.permissions
  }).requirementFlags;
  var externalRequirementFlags = getFlags({
    requirement: requirement,
    selectedTab: selectedTab,
    permissions: initialProps.permissions
  }).externalRequirementFlags;
  var entityPopup = getEntityPopup({
    requirement: requirement,
    userIsAdmin: userIsAdmin,
    entityName: entityName
  });
  var onToggleQuestionsModal = React.useCallback(function () {
    setQuestionsModalVisible(!questionsModalVisible);
  }, [questionsModalVisible]);
  var completed = (requirement === null || requirement === void 0 ? void 0 : requirement.status) === 'status_completed';
  var applicationStatus = getApplicationStatus(application);
  var applicationStatusMessage = getApplicationStatusMessage(application);
  var isStatusReadOnly = statusReadOnly || !userPermissions.update_requirement_status || status === 'missing' || status === 'no_status' || (requirement === null || requirement === void 0 ? void 0 : requirement.requirement_template_type) === 'payment';
  var statusOptions = getStatusOptions(status);
  var isInactive = requiredState === 'inactive';
  var onQuestionRequirementClick = !['canceled', 'withdraw'].includes(applicationStatus) ? onToggleQuestionsModal : function () {};
  var _useEventTracker2 = useEventTracker(),
    trackEvent = _useEventTracker2.trackEvent;
  var onViewLinkedApplications = function onViewLinkedApplications() {
    return setLinkedApplicationsModalVisible(!linkedApplicationsModalVisible);
  };
  var handleEdit = function handleEdit() {
    if (completed || (requirement === null || requirement === void 0 ? void 0 : requirement.status) === 'status_pending_receipt' || (requirement === null || requirement === void 0 ? void 0 : requirement.status) === 'status_pending_verification') {
      return;
    }
    if (onEdit && typeof onEdit === 'function') {
      onEdit(requirement === null || requirement === void 0 ? void 0 : requirement.id);
    }
  };
  var statusChange = onStatusChange ? function (status_value) {
    return onStatusChange(requirement === null || requirement === void 0 ? void 0 : requirement.id, status_value);
  } : null;
  useEffect(function () {
    if (!(requirement !== null && requirement !== void 0 && requirement.order_in_progress) || !(requirement !== null && requirement !== void 0 && requirement.id)) {
      return;
    }
    refreshRequirementStatus({
      requirementId: requirement.id
    }, {
      onSuccess: function onSuccess() {
        trackPaymentRequirementEvent({
          action: 'Refresh requirement status (page load)',
          event: 'Single Application - Payment Requirements - Successfully Refreshed Requirement Status After Page Load'
        });
      },
      onError: function onError(error) {
        trackPaymentRequirementEvent({
          action: 'Refresh requirement status (page load)',
          event: 'Single Application - Payment Requirements - Failed To Refresh Requirement Status After Page Load',
          error: error
        });
        setFulfillmentMessage({
          type: 'error',
          code: FulfillmentMessageCode.PAYMENT_SYSTEM_DOWN
        });
      }
    });
  }, [requirement.id, requirement.requirement_template_type]);
  var _useDeleteAndRefreshR = useDeleteAndRefreshRequirementAttachments(),
    deleteRequirementAttachments = _useDeleteAndRefreshR.deleteRequirementAttachments,
    isDeletingRequirementAttachments = _useDeleteAndRefreshR.isDeletingRequirementAttachments;
  var requirementInternalTitle = "".concat(displayId ? "".concat(displayId, ": ") : '').concat(requirement !== null && requirement !== void 0 && requirement.internal_title ? requirement === null || requirement === void 0 ? void 0 : requirement.internal_title : requirement === null || requirement === void 0 ? void 0 : requirement.title);
  if (!requirement) {
    return null;
  }
  return /*#__PURE__*/React.createElement(RequirementCardWrapper, {
    role: "listitem",
    onClick: function onClick() {
      if (preview && previewRequirement && typeof previewRequirement === 'function') {
        previewRequirement(requirement);
      }
    },
    id: "req-".concat(requirement.id),
    "aria-label": requirement.title,
    tabIndex: "0",
    activelyPreviewing: activelyPreviewing,
    requiredState: requiredState,
    preview: preview,
    highlighted: highlightedRequirementId && highlightedRequirementId === requirement.id.toString(),
    faded: highlightedRequirementId && highlightedRequirementId !== requirement.id.toString()
  }, /*#__PURE__*/React.createElement(RequiredStateOptions, {
    options: options,
    canEditRequiredState: userPermissions.update_requirement_optionality,
    requirement: requirement,
    name: name,
    requiredState: requiredState,
    tooltipMessage: requiredStateTooltip,
    tooltipId: "tooltip-".concat(requirement.id),
    applicationStatusMessage: applicationStatusMessage,
    reloadAggregatedData: reloadAggregatedData
  }), /*#__PURE__*/React.createElement(RequirementContentWrapper, null, !preview && userIsAdmin && isApplicantRequirement && /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Tabs, {
    currentTab: currentTab,
    divider: true,
    onChangeTab: function onChangeTab(tab) {
      trackEvent({
        event: tab === 1 ? 'Single Application - Applicant Requirements - Clicked External Tab' : 'Single Application - Applicant Requirements - Clicked Internal Tab',
        data: {
          requirementType: requirement === null || requirement === void 0 ? void 0 : requirement.requirement_template_type,
          requirementStatus: isInactive ? 'status_no_status' : requirement === null || requirement === void 0 ? void 0 : requirement.status,
          applicationStage: requirement === null || requirement === void 0 ? void 0 : requirement.application_stage
        }
      });
      setCurrentTab(tab);
    },
    items: [{
      title: 'Internal View',
      id: internalTabId,
      'aria-controls': "internal-view-".concat(requirement.id)
    }, {
      title: 'External View (View Only)',
      id: externalTabId,
      'aria-controls': "external-view-".concat(requirement.id)
    }]
  })), (userIsAdmin || !isApplicantRequirement) && /*#__PURE__*/React.createElement(TabPanelWrapper, {
    id: "internal-view-".concat(requirement.id),
    active: currentTab === 0,
    "aria-labelledby": internalTabId,
    shouldBePanel: !preview && isApplicantRequirement
  }, /*#__PURE__*/React.createElement(RequirementCardContent, {
    title: isApplicantRequirement ? requirement.title : requirementInternalTitle,
    internalTitle: isApplicantRequirement ? requirementInternalTitle : null,
    description: requirement.internal_description ? requirement.internal_description : requirement.description,
    preview: preview,
    conditionTitle: conditionTitle,
    onToggleConditionModal: onToggleConditionModal,
    conditionValues: conditionValues,
    requirementFlags: requirementFlags,
    showFullfillRequirementButton: true,
    showFlywireButtons: true,
    handleEdit: userIsAdmin ? handleEdit : null,
    status: status,
    isInactive: isInactive,
    onStatusChange: statusChange,
    statusReadOnly: isStatusReadOnly,
    statusOptions: statusOptions,
    requirement: requirement,
    programId: programId,
    schoolGroupId: schoolGroupId,
    isRefreshingRequirementStatus: isRefreshingRequirementStatus,
    fulfillmentMessage: fulfillmentMessage,
    entityPopup: entityPopup,
    userIsAdmin: userIsAdmin,
    userPermissions: userPermissions,
    onViewLinkedApplications: onViewLinkedApplications,
    displayAdditionalAttachments: displayAdditionalAttachments,
    displayExternalLinks: displayExternalLinks,
    applicationStatus: applicationStatus,
    applicationStatusMessage: applicationStatusMessage,
    onFiles: onFiles,
    onQuestionRequirementClick: onQuestionRequirementClick,
    setFulfillmentMessage: setFulfillmentMessage,
    onToggleQuestionsModal: onToggleQuestionsModal,
    onSelectAttachment: onSelectAttachment,
    dispatch: dispatch,
    RemoveFileDialog: RemoveFileDialog,
    reloadAggregatedData: reloadAggregatedData,
    HybridRequirementDecisionReasons: HybridRequirementDecisionReasons,
    HybridRequirementDialogButton: HybridRequirementDialogButton,
    aggregatedDataRequirements: aggregatedDataRequirements
  })), isApplicantRequirement && /*#__PURE__*/React.createElement(TabPanelWrapper, {
    id: "external-view-".concat(requirement.id),
    active: currentTab === 1 || !userIsAdmin,
    "aria-labelledby": externalTabId,
    shouldBePanel: userIsAdmin
  }, /*#__PURE__*/React.createElement(RequirementCardContent, {
    title: requirement.title,
    description: requirement.description,
    preview: preview,
    requirementFlags: externalRequirementFlags,
    showFullfillRequirementButton: !userIsAdmin,
    showFlywireButtons: !userIsAdmin,
    status: status,
    isInactive: isInactive,
    onStatusChange: statusChange,
    statusReadOnly: true,
    statusOptions: statusOptions,
    requirement: requirement,
    programId: programId,
    schoolGroupId: schoolGroupId,
    isRefreshingRequirementStatus: isRefreshingRequirementStatus,
    fulfillmentMessage: fulfillmentMessage,
    entityPopup: entityPopup,
    userPermissions: userPermissions,
    onViewLinkedApplications: onViewLinkedApplications,
    displayAdditionalAttachments: displayAdditionalAttachments,
    displayExternalLinks: displayExternalLinks,
    applicationStatus: applicationStatus,
    applicationStatusMessage: applicationStatusMessage,
    onFiles: onFiles,
    onQuestionRequirementClick: onQuestionRequirementClick,
    setFulfillmentMessage: setFulfillmentMessage,
    onToggleQuestionsModal: onToggleQuestionsModal,
    onSelectAttachment: onSelectAttachment,
    dispatch: dispatch,
    RemoveFileDialog: RemoveFileDialog,
    reloadAggregatedData: reloadAggregatedData,
    HybridRequirementDecisionReasons: HybridRequirementDecisionReasons,
    HybridRequirementDialogButton: HybridRequirementDialogButton,
    aggregatedDataRequirements: aggregatedDataRequirements
  }))), requirement.requirement_template_type === 'questions' && questionsModalVisible && /*#__PURE__*/React.createElement(QuestionsModal, {
    questions: questions,
    questionsModalVisible: questionsModalVisible,
    onToggleQuestionsModal: onToggleQuestionsModal,
    onSuccess: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            trackEvent({
              event: 'Single Application - Application Requirements - Fulfilled',
              data: {
                requirementClassification: requirement.classification,
                requiredState: requirement.required_state,
                requirementCategory: requirement.requirement_category,
                requirementTemplateId: requirement.requirement_template_id,
                requirementInstanceId: requirement.id,
                applicationStatus: applicationStatusMessage,
                requirementType: requirement.requirement_template_type,
                applicationStage: application.current_stage
              }
            });
            if (!(dispatch && application !== null && application !== void 0 && application.id)) {
              _context.next = 4;
              break;
            }
            _context.next = 4;
            return loadBaseApplication(application.id, dispatch);
          case 4:
            reloadAggregatedData();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })),
    requirementTitle: requirement.title,
    requirementId: requirement.id,
    requirementStatus: status,
    userPermissions: userPermissions
  }), !preview && useDocumentUpload && userPermissions.fulfil_requirement && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropzoneOverlay, {
    dragging: dropzoneDragging,
    hovering: dropzoneHovering
  }), /*#__PURE__*/React.createElement(ProgressBarOverlay, progressProps)), /*#__PURE__*/React.createElement(ReactTooltip, {
    id: "tooltip-".concat(requirement.id),
    multiline: true
  }), linkedApplicationsModalVisible && /*#__PURE__*/React.createElement(Modal, {
    onClickOff: onViewLinkedApplications
  }, /*#__PURE__*/React.createElement(LinkedApplicationsListModal, {
    onViewLinkedApplications: onViewLinkedApplications,
    requirementTemplateID: requirement.requirement_template_id,
    internalTitle: requirement.internal_title,
    requirementID: requirement.id
  })), /*#__PURE__*/React.createElement(DocumentVerificationModal, {
    open: verificationModalAttachmentIds.length > 0,
    onClose: function onClose() {
      return setVerificationModalAttachmentIds([]);
    },
    deleting: isDeletingRequirementAttachments,
    onDelete: function onDelete(attachmentIds) {
      deleteRequirementAttachments({
        attachmentIds: attachmentIds,
        requirementId: requirement.id,
        requirementType: requirement.requirement_template_type,
        applicationId: initialProps.id
      }, {
        onSuccess: function onSuccess() {
          setVerificationModalAttachmentIds([]);
        },
        onError: function onError(err) {
          if (err instanceof UnknownDeleteRequirementAttachmentError && err.successfullyDeletedAttachmentIds.length > 0) {
            raiseErrorMessage('Failed to delete some documents');
          } else {
            raiseErrorMessage('Failed to delete documents');
          }
          setVerificationModalAttachmentIds([]);
        }
      });
    },
    documents: (requirement.attachments || []).filter(function (requirementAttachment) {
      return requirementAttachment && verificationModalAttachmentIds.includes(requirementAttachment.id.toString());
    }).map(function (requirementAttachment) {
      return {
        id: requirementAttachment.id,
        fileName: requirementAttachment.fileName,
        documentVerificationResults: requirementAttachment.automatedVerificationResults.map(function (item) {
          return item.resultCode;
        }) || []
      };
    }),
    trackingData: {
      requirementId: requirement.id,
      requirementTemplateId: requirement.requirement_template_id,
      requirementType: requirement.requirement_template_type,
      categoryId: requirement.requirement_category
    },
    requirement: requirement
  }));
};
var getCondition = function getCondition(_ref3) {
  var userIsAdmin = _ref3.userIsAdmin,
    requirement = _ref3.requirement;
  var conditionTitle;
  var conditionValues;
  if (userIsAdmin && requirement !== null && requirement !== void 0 && requirement.created_with_condition) {
    try {
      var condition = JSON.parse(requirement === null || requirement === void 0 ? void 0 : requirement.created_with_condition);
      var conditionGroups = condition.condition_json.condition_groups[0].clauses;
      conditionTitle = "".concat(condition.id, " : ").concat(condition.condition_json.title);
      conditionValues = {
        title: condition.condition_json.title,
        description: condition.condition_json.description,
        condition_groups: conditionGroups
      };
    } catch (_unused) {
      // Empty
    }
  }
  return {
    conditionTitle: conditionTitle,
    conditionValues: conditionValues
  };
};
var getOptions = function getOptions(_ref4) {
  var requirement = _ref4.requirement,
    requiredState = _ref4.requiredState;
  var modifiedRequiredStateOptions = requiredStateOptions;
  if ((requirement === null || requirement === void 0 ? void 0 : requirement.requirement_template_type) === 'payment' && ['status_completed', 'status_pending_receipt', 'status_pending_verification'].includes(requirement === null || requirement === void 0 ? void 0 : requirement.status)) {
    modifiedRequiredStateOptions = ['required', 'optional'];
  }
  return modifiedRequiredStateOptions.filter(function (option) {
    return option !== requiredState;
  }).map(function (o) {
    return {
      label: capitalize(o),
      value: o
    };
  });
};
var getFlags = function getFlags(_ref5) {
  var _requirement$validati, _requirement$validati2;
  var requirement = _ref5.requirement,
    selectedTab = _ref5.selectedTab,
    permissions = _ref5.permissions;
  // hidden is not to be displayed on the actions tab due to confusion with icons
  var flags = {
    hidden: selectedTab === 'Actions' ? false : isInternalRequirement(requirement) || (requirement === null || requirement === void 0 ? void 0 : requirement.hidden_unless_admin),
    applyboardRequirement: requirement === null || requirement === void 0 ? void 0 : requirement.applyboard_requirement,
    manual: requirement === null || requirement === void 0 ? void 0 : requirement.manual,
    notarization: requirement === null || requirement === void 0 ? void 0 : requirement.requires_notarization,
    plagiarism: isNumeric(requirement === null || requirement === void 0 ? void 0 : (_requirement$validati = requirement.validation_rules) === null || _requirement$validati === void 0 ? void 0 : (_requirement$validati2 = _requirement$validati.plagiarism) === null || _requirement$validati2 === void 0 ? void 0 : _requirement$validati2.max_plagiarism_score),
    modified: requirement === null || requirement === void 0 ? void 0 : requirement.modified
  };
  var requirementFlags = [];
  var externalRequirementFlags = [];
  Object.keys(flags).forEach(function (flag) {
    if (!flags[flag]) return;
    if (flag === 'plagiarism' && !(permissions !== null && permissions !== void 0 && permissions.view_internal_notices)) return;
    requirementFlags.push({
      flagName: flag,
      toolTipMsg: getRequirementFlagToolipMsg(flag)
    });
    if (['applyboard_requirement', 'notarization'].includes(flag)) {
      externalRequirementFlags.push({
        flagName: flag,
        toolTipMsg: getRequirementFlagToolipMsg(flag)
      });
    }
  });
  return {
    requirementFlags: requirementFlags,
    externalRequirementFlags: externalRequirementFlags
  };
};
var TabPanelWrapper = function TabPanelWrapper(_ref6) {
  var id = _ref6.id,
    active = _ref6.active,
    shouldBePanel = _ref6.shouldBePanel,
    children = _ref6.children,
    props = _objectWithoutProperties(_ref6, _excluded);
  if (shouldBePanel) {
    return /*#__PURE__*/React.createElement(TabPanel, {
      id: id,
      active: active,
      "aria-labelledby": props['aria-labelledby']
    }, children);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
var getApplicationStatus = function getApplicationStatus(application) {
  var applicationStatus = application.status;
  var result = null;
  statuses.forEach(function (status) {
    if (applicationStatus[status]) {
      result = status;
    }
  });
  return result;
};
var getStatusOptions = function getStatusOptions(current_status) {
  switch (current_status) {
    case 'completed':
      return ['not_approved'];
    case 'reviewing':
      return ['completed', 'not_approved'];
    case 'not_approved':
      return ['completed'];
    default:
      break;
  }
  return [];
};
export var buildQuestionsArray = function buildQuestionsArray(_ref7) {
  var requirement = _ref7.requirement,
    _ref7$previewing = _ref7.previewing,
    previewing = _ref7$previewing === void 0 ? false : _ref7$previewing;
  var returnArray = [];
  if ((requirement === null || requirement === void 0 ? void 0 : requirement.requirement_template_type) !== 'questions') {
    return returnArray;
  }
  requirement === null || requirement === void 0 ? void 0 : requirement.application_questions.sort(function (a, b) {
    return a.id - b.id;
  }).forEach(function (q, idx) {
    if (q.answers.length <= 1) {
      var newQ = _objectSpread(_objectSpread({}, q), {}, {
        answer: q.answers[0] ? q.answers[0] : null,
        status: q.answers[0] ? q.answers[0].status : q.status,
        questionNum: idx + 1,
        duplicated: false
      });
      if (newQ.answer && newQ.question_format === 'checkboxes' && typeof newQ.answer.answer === 'string') {
        newQ.answer = _objectSpread(_objectSpread({}, newQ.answer), {}, {
          answer: JSON.parse(q.answers[0].answer)
        });
      }
      delete newQ.answers;
      returnArray.push(newQ);
    } else {
      q.answers.forEach(function (a, i) {
        var newQ = _objectSpread(_objectSpread({}, q), {}, {
          answer: a,
          duplicated: false,
          status: a.status,
          question: "".concat(q.question, " (ATTEMPT ").concat(i + 1, ")"),
          questionNum: idx + 1
        });
        if (newQ.question_format === 'checkboxes' && typeof newQ.answer.answer === 'string') {
          newQ.answer = _objectSpread(_objectSpread({}, newQ.answer), {}, {
            answer: JSON.parse(a.answer)
          });
        }
        delete newQ.answers;
        returnArray.push(newQ);
      });
    }
    if (q.status === 'disapproved' && !previewing) {
      var duplicatedQ = _objectSpread(_objectSpread({}, q), {}, {
        answer: null,
        duplicated: true,
        status: 'normal',
        question: "".concat(q.question, " (UPDATE)"),
        questionNum: idx + 1
      });
      delete duplicatedQ.answers;
      returnArray.push(duplicatedQ);
    }
  });
  return returnArray;
};
var getRequirementFlagToolipMsg = function getRequirementFlagToolipMsg(flag) {
  if (flag === 'hidden') {
    return 'This requirement is hidden from external users.';
  }
  if (flag === 'plagiarism') {
    return "PlagiarismCheck: Files uploaded to this requirement will be sent to ApplyBoard's 3rd Party Service.";
  }
  return '';
};
var getRequiredStateTooltip = function getRequiredStateTooltip(_ref8) {
  var userPermissions = _ref8.userPermissions,
    requirement = _ref8.requirement;
  if (userPermissions !== null && userPermissions !== void 0 && userPermissions.update_requirement_optionality) {
    switch (requirement === null || requirement === void 0 ? void 0 : requirement.inactive_source) {
      case 'inactive_source_manual':
        return 'Updated to "Inactive" manually';
      case 'inactive_source_program_unlinked':
        return 'Updated to "Inactive" as it was removed from program requirements';
      case 'inactive_source_application_status_change':
        return 'Updated to "Inactive" due to application status update';
      case 'inactive_source_profile_changed':
        return 'Updated to "Inactive" due to student profile update';
      default:
        return;
    }
  }
};
var getEntityPopup = function getEntityPopup(_ref9) {
  var userIsAdmin = _ref9.userIsAdmin,
    requirement = _ref9.requirement,
    entityName = _ref9.entityName;
  if (userIsAdmin && requirement !== null && requirement !== void 0 && requirement.entity_level_id && requirement !== null && requirement !== void 0 && requirement.entity_level && (requirement === null || requirement === void 0 ? void 0 : requirement.manual) === false) {
    return "".concat(requirement.entity_level, " ").concat(requirement.entity_level_id, ": ").concat(entityName);
  }
  return '';
};
export default reduxForm({
  form: requiredStateOptionsForm,
  touchOnChange: true,
  enableReinitialize: true
})(RequirementCard);